export default __webpack_public_path__ + "static/media/logo-app2f.ac9bc141.svg";